import { capitalize } from 'lodash';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { RecordingWestburyContributionsInner } from 'shared_components/generated/admin';

const getMappedConfidencePattern = (confidencePattern: string): string => {
  const confidencePatternMap: Record<string, string> = {
    track_level_contribution: 'Track-Level Contribution',
    inferred_from_track: 'Inferred from Track-Level Contribution',
    inferred_from_release: 'Inferred from Release-Level Contribution',
    // REMOVE- pre-split pattern still held in OpenSearch; drop once the index is reindexed
    inferred_contribution: 'Inferred Contribution',
    released_by_artist: 'Released by Artist (Solo)',
    release_level_contribution: 'Release-Level Contribution',
    associated_with_ppl: 'Associated with PPL',
    released_by_band_artist: 'Released by Artist (Band)',
    non_identifying_sources: 'Non-Identifying Sources (Spotify, Deezer)',
    version_of_recording: 'Version of Recording (non-derivative)',
    ppl_only_source: 'PPL as Only Source',
    unresolved_position: 'Unresolved position for explicit payable roles',
    manual_update: 'Manually Updated',
    unknown: 'Unknown',
  };
  return confidencePatternMap[confidencePattern] ?? confidencePattern;
};

function getPillClassName(confidenceCategory: string): string {
  return [
    'tw-inline-flex tw-rounded-xs tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-uppercase tw-h-6',
    confidenceCategory === '5' ? 'tw-bg-[#AAB2B9] tw-text-black' : '',
    confidenceCategory === '4' ? 'tw-bg-[#FF2600]' : '',
    confidenceCategory === '3' ? 'tw-bg-[#FF8A00]' : '',
    confidenceCategory === '2' ? 'tw-bg-[#F6FF00] tw-text-black' : '',
    confidenceCategory === '1' ? 'tw-bg-[#6EE038] tw-text-black' : '',
  ]
    .filter(Boolean)
    .join(' ');
}

export function ContributionPill({
  contribution,
}: {
  contribution: RecordingWestburyContributionsInner;
}) {
  const pillClassName = getPillClassName(contribution.confidenceCategory);

  return (
    <OverlayTrigger
      delay={{ hide: 50, show: 50 }}
      placement="top"
      flip
      popperConfig={{
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
            },
          },
        ],
      }}
      overlay={(props) => (
        <Tooltip {...props} className="black-bg tw-max-w-xs !tw-z-[9999]">
          <div className="tw-flex tw-justify-start tw-items-start tw-flex-col tw-gap-2 tw-p-2 tw-px-1">
            <div className="tw-font-semibold">
              <span className={pillClassName}>
                {capitalize(contribution.contribution)}
              </span>
            </div>
            <div className="tw-text-sm tw-text-gray-300 tw-break-words tw-text-left">
              {getMappedConfidencePattern(contribution.confidencePattern)}
            </div>
          </div>
        </Tooltip>
      )}
    >
      <span className={pillClassName}>
        {capitalize(contribution.contribution)}
      </span>
    </OverlayTrigger>
  );
}
